/* Zenfusion cart drawer helpers: free-shipping currency conversion + upsell add buttons.
   Works with Dawn's cart drawer re-rendering (custom elements re-run on insert; clicks are delegated). */
if (!customElements.get('zf-free-shipping')) {
  class ZfFreeShipping extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-convert')) return;
      const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      const threshold = Math.round(parseInt(this.dataset.threshold, 10) * rate);
      const total = parseInt(this.dataset.total, 10) || 0;
      const remaining = threshold - total;
      const pct = threshold > 0 ? Math.min(100, Math.floor((total * 100) / threshold)) : 100;
      const msgEl = this.querySelector('[data-zf-fs-message]');
      const fill = this.querySelector('[data-zf-fs-fill]');
      const track = this.querySelector('[role="progressbar"]');
      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', pct);
      this.classList.toggle('is-complete', remaining <= 0);
      if (!msgEl) return;
      if (remaining <= 0) {
        msgEl.textContent = this.dataset.success || '';
        return;
      }
      let amount;
      try {
        amount = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency,
        }).format(remaining / 100);
      } catch (e) {
        amount = (remaining / 100).toFixed(2) + ' ' + this.dataset.currency;
      }
      const parts = (this.dataset.message || '').split('[amount]');
      msgEl.textContent = '';
      parts.forEach((part, i) => {
        msgEl.appendChild(document.createTextNode(part));
        if (i < parts.length - 1) {
          const strong = document.createElement('strong');
          strong.textContent = amount;
          msgEl.appendChild(strong);
        }
      });
    }
  }
  customElements.define('zf-free-shipping', ZfFreeShipping);
}

if (!window.zfCartUpsellBound) {
  window.zfCartUpsellBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-zf-cart-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const id = parseInt(button.dataset.zfCartAdd, 10);
    if (!id || typeof window.zfAddToCart !== 'function') return;
    const wrap = button.closest('.zf-cart-upsell');
    const error = wrap && wrap.querySelector('.zf-cart-upsell__error');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await window.zfAddToCart([{ id, quantity: 1 }], button);
    } catch (err) {
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
}
